export default __webpack_public_path__ + "static/media/about-img.b322ecb4.jpg";